import { Button, ButtonMode, ButtonSize, Loader } from '@creditsights/styleguide-web';
import { ReactElement, useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useSetRecoilState } from 'recoil';
import { toasterState } from '../../../atoms/toaster.atom';
import { CONSENT_MAPPER, USER_CONSENTS_KEY } from '../../../Constants';
import useFetchUserConsents from '../../../hooks/user/useFetchUserConsents';
import useSaveUserConsents from '../../../hooks/user/useSaveUserConsents';
import UserAccountHeader from '../UserAccountHeader';
import './ComplianceAndConsent.scss';

function ComplianceAndConsent(): ReactElement {
  const queryClient = useQueryClient();
  const showToaster = useSetRecoilState(toasterState);
  const { data: consents, isLoading } = useFetchUserConsents();
  const [status, setStatus] = useState<any>({});
  const { mutate: saveConsents, isLoading: isSaving, isSuccess, reset } = useSaveUserConsents();

  useEffect(() => {
    if (consents && consents.length > 0) {
      const obj: any = {};
      for (const consent of consents) {
        obj[consent.configuration.id] = consent.consent || false;
      }

      setStatus(obj);
    }
  }, [consents]);

  useEffect(() => {
    if (isSuccess) {
      showToaster({
        text: 'Your consents were saved',
      });
      queryClient.invalidateQueries([USER_CONSENTS_KEY]);
      reset();
    }
  }, [isSuccess]);

  const handleChange = (id) => {
    setStatus((s) => ({
      ...s,
      [id]: !s[id],
    }));
  };

  const save = () => {
    const obj: any[] = [];

    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const id in status) {
      obj.push({
        configurationId: id,
        consent: status[id],
      });
    }

    saveConsents(obj);
  };

  if (isLoading) {
    return <Loader className="cs-loader" position="center" />;
  }
  return (
    <div className="cs-compliance-and-consent">
      <UserAccountHeader />
      <div className="contents">
        <div className="title">Compliance & Consent</div>
        <div className="consents-ctx">
          <form className="ui form">
            {consents &&
              consents.map(({ configuration }) => (
                <div className="consent" key={`consent-${configuration.id}`}>
                  <div className="title">{CONSENT_MAPPER[configuration.type]}</div>
                  <div className="consent-text" dangerouslySetInnerHTML={{ __html: configuration.text }} />
                  <div className="toggle-ctx" onClick={() => handleChange(configuration.id)}>
                    <i className={`toggle icon ${status[configuration.id] ? 'on' : 'off'}`} />
                    <span>I have read and accepted the agreement</span>
                  </div>
                </div>
              ))}
            <div className="buttons-ctx">
              <Button onClick={save} mode={ButtonMode.PRIMARY} size={ButtonSize.MEDIUM} loading={isSaving} disabled={isSaving}>
                Save
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ComplianceAndConsent;
